var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTranscriptionOff = function SvgTranscriptionOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3327 22.2625V7.33366C29.3327 5.8609 28.1388 4.66699 26.666 4.66699H11.7371L14.4038 7.33364H26.6661V19.5959L29.3327 22.2625ZM16.6661 16.667L19.3327 19.3336H9.33272V16.667H16.6661ZM21.0705 14.0003H21.3327V11.3336H18.4038L21.0705 14.0003ZM11.3327 11.3336L13.9994 14.0003H9.33272V11.3336H11.3327ZM7.33272 7.33364H5.33272V23.3336H10.6661V26.2613L15.3503 23.3336H23.3327L25.9994 26.0003H16.1151L7.99935 31.0727V26.0003H5.33268C3.85992 26.0003 2.66602 24.8064 2.66602 23.3337V7.33366C2.66602 6.06687 3.54933 5.00639 4.73363 4.73455L7.33272 7.33364Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.88388,
    y1: 2.11612,
    x2: 30.8839,
    y2: 29.1161,
    stroke: "white",
    strokeWidth: 2.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranscriptionOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TranscriptionOff.f331f177.svg";
export { ForwardRef as ReactComponent };